import React, { useState, useEffect } from "react";
import "./newsSection.scss";
import NewsCard from "../../../../assets/images/news-card.png";
import NewsCardImage from "../../../../assets/images/news-sec-card.png";
import axios from "axios";
import { NavLink } from "react-router-dom";

export default function NewsSection() {
  const [newsData, setNewsData] = useState<any>([]);

  useEffect(() => {
    handleNews();
  }, []);

  const handleNews = async () => {
    await axios
      .get("https://api.deutscher.rejoicehub.com/api/v1/news/find")
      .then((res: any) => {
        setNewsData(res?.data?.payload?.data);
      })
      .catch((err: any) => {
        console.log("err", err);
      });
  };
  console.log("Aaaaaaaaaaaa", newsData);

  return (
    <>
      <div>
        {newsData && (
          <div className="new-section-all-content-alignment">
            <div className="container">
              <div className="page-title">
                <div className="text-grid">
                  <div className="text-grid-items">
                    <div className="line"></div>
                  </div>
                  <div className="text-grid-items">
                    <h1>News</h1>
                  </div>
                </div>
              </div>
              <div className="grid">
                <div className="grid-items">
                  <NavLink to={`/news-details/${newsData[0]?._id}`}>
                    <div className="card-details">
                      <h2
                        className="animate__fadeInUp animate__animated wow"
                        data-wow-offset="200"
                      >
                        {newsData[0]?.description} ...{" "}
                      </h2>
                      <span
                        className="animate__fadeInUp animate__animated wow"
                        data-wow-offset="200"
                      >
                        MEHR ERFAHREN
                      </span>
                    </div>{" "}
                    <div className="card-image">
                      <img src={newsData[0]?.image} alt="NewsCard" />
                    </div>
                  </NavLink>
                </div>

                <div className="grid-items">
                  <NavLink to={`/news-details/${newsData[1]?._id}`}>
                    <div className="card-details">
                      <h2
                        className="animate__fadeInUp animate__animated wow"
                        data-wow-offset="200"
                      >
                        {newsData[1]?.description} ...{" "}
                      </h2>
                      <span
                        className="animate__fadeInUp animate__animated wow"
                        data-wow-offset="200"
                      >
                        MEHR ERFAHREN
                      </span>
                    </div>
                    <div className="card-image">
                      <img src={newsData[1]?.image} alt="NewsCard" />
                    </div>
                  </NavLink>
                </div>
              </div>
              <div className="card-grid">
                {newsData[2] && (
                  <div className="card-grid-items">
                    <NavLink to={`/news-details/${newsData[2]?._id}`}>
                      <div className="sec-card-details">
                        <h4
                          className="animate__fadeInUp animate__animated wow"
                          data-wow-offset="200"
                        >
                          {" "}
                          {newsData[2]?.description} ...{" "}
                        </h4>
                        <span
                          className="animate__fadeInUp animate__animated wow"
                          data-wow-offset="200"
                        >
                          MEHR ERFAHREN
                        </span>
                      </div>
                      <div className="sec-card-image">
                        <img src={newsData[2]?.image} alt="NewsCardImage" />
                      </div>
                    </NavLink>
                  </div>
                )}
                {newsData[3] && (
                  <div className="card-grid-items">
                    <NavLink to={`/news-details/${newsData[3]?._id}`}>
                      <div className="sec-card-details">
                        <h4
                          className="animate__fadeInUp animate__animated wow"
                          data-wow-offset="200"
                        >
                          {newsData[3]?.description}...
                        </h4>
                        <span
                          className="animate__fadeInUp animate__animated wow"
                          data-wow-offset="200"
                        >
                          MEHR ERFAHREN
                        </span>
                      </div>
                      <div className="sec-card-image">
                        <img src={newsData[3]?.image} alt="NewsCardImage" />
                      </div>
                    </NavLink>
                  </div>
                )}
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
}
